import React from "react";
import PropTypes from "prop-types";

function EventDetailButton({ icon, children, onClick, tintColor, buttonTextColor }) {
    return (
        <div
            className="event-detail-button"
            onClick={ onClick }
            style={{
                cursor: onClick ? "pointer" : "default",
            }}
        >
            <div className="event-detail-button-icon">
                <i className={ icon } style={{ color: (tintColor ?? "#fae33d") }}/>
            </div>
            <span className="event-detail-button-text" style={{ color: (buttonTextColor ?? "black") }}>
                { children }
            </span>
        </div>
    );
}
EventDetailButton.propTypes = {
    icon: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    tintColor: PropTypes.string,
    buttonTextColor: PropTypes.string,
};

export default React.memo(EventDetailButton);
